import Checkbox from './component';

export default Checkbox;
